export interface ProductListStateModel {
	pagination?: number;
	filter?: string;
}

export class ProductStateModel {
	productList?: ProductListStateModel;
}